/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Backdrop, useTheme } from "@mui/material";
import { Spinner } from "./Spinner";
import { FC } from "react";

interface Props {
  open?: boolean;
}

export const SpinnerBack: FC<Props> = ({ open = true }) => {
  const theme = useTheme();

  return (
    <Backdrop open={open} sx={{ zIndex: theme.zIndex.modal + 10 }}>
      <Spinner />
    </Backdrop>
  );
};
